module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3fkT0"))).then(() => parcelRequire('d0iPb'));